import {efaPersonalDetails} from './efa-personal-details-en.i18n';

export const en = {
  efaPersonalDetails
};
